<script setup>
// O cabeçalho da conversa de teste (L-25): a foto e o nome do agente, o selo de onde se testa e o
// "Recomeçar". O selo vem de quem usa ("Ambiente de teste", na página do link). O "Recomeçar" só
// aparece com conversa na tela, e quem usa só limpa a conversa depois de o servidor confirmar: se
// não der, o aviso fica embaixo do cabeçalho, e a conversa continua. Sem nome, a foto cai no ícone
// do agente: o ícone padrão do Avatar tem um texto do painel que a página não tem.
import { useI18n } from 'vue-i18n';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  nome: { type: String, default: '' },
  foto: { type: String, default: '' },
  selo: { type: String, default: '' },
  podeRecomecar: { type: Boolean, default: false },
  recomecando: { type: Boolean, default: false },
  ocupada: { type: Boolean, default: false },
  falhaAoRecomecar: { type: Boolean, default: false },
});

const emit = defineEmits(['recomecar']);

const { t } = useI18n();
</script>

<template>
  <div class="shrink-0">
    <header class="flex items-center gap-3 px-4 py-3 border-b border-n-weak">
      <Avatar
        :name="nome"
        :src="foto"
        :icon-name="nome ? null : 'i-lucide-bot'"
        :size="40"
        rounded-full
      />
      <div class="flex flex-col min-w-0 gap-0.5">
        <p class="text-sm font-semibold truncate text-n-slate-12">
          {{ nome }}
        </p>
        <span
          v-if="selo"
          class="self-start px-1.5 py-0.5 text-[11px] font-medium rounded-md bg-n-amber-3 text-n-amber-11"
        >
          {{ selo }}
        </span>
      </div>
      <Button
        v-if="podeRecomecar"
        :label="t('CONVERSA_DE_TESTE.RESTART')"
        icon="i-lucide-rotate-ccw"
        slate
        faded
        xs
        class="ml-auto shrink-0"
        :is-loading="recomecando"
        :disabled="ocupada"
        @click="emit('recomecar')"
      />
    </header>
    <p
      v-if="falhaAoRecomecar"
      class="px-4 py-2 text-xs text-center bg-n-ruby-3 text-n-ruby-11"
      role="alert"
    >
      {{ t('CONVERSA_DE_TESTE.RESTART_ERROR') }}
    </p>
  </div>
</template>
